import { useEffect, useState } from 'react';
import { assetUrl } from './api';

/**
 * Resolve an R2 asset key to a tokened /assets URL (async — the 15-min asset
 * token may need fetching). Returns null while resolving or when key is empty.
 */
export function useAssetUrl(key: string | null | undefined): string | null {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    let alive = true;
    setUrl(null);
    if (!key) return;
    assetUrl(key).then((u) => {
      if (alive) setUrl(u);
    });
    return () => {
      alive = false;
    };
  }, [key]);
  return url;
}
